import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateAccountLocationDetailsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLocationDetailsInput;
}>;

export type UpdateAccountLocationDetailsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLocationDetails?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLocationDetailsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountLocationDetailsDocument = /*#__PURE__*/ gql`
  mutation updateAccountLocationDetails($input: UpdateAccountLocationDetailsInput!) {
    updateAccountLocationDetails(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateAccountLocationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountLocationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountLocationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountLocationDetailsMutation, { data, loading, error }] = useUpdateAccountLocationDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountLocationDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountLocationDetailsMutationResult,
    UpdateAccountLocationDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateAccountLocationDetailsMutationResult, UpdateAccountLocationDetailsMutationVariables>(
    UpdateAccountLocationDetailsDocument,
    options
  );
}
export type UpdateAccountLocationDetailsMutationHookResult = ReturnType<typeof useUpdateAccountLocationDetailsMutation>;
